import connectedStore from 'yola-editor/src/js/store/connected-store';
import selectors from '../selectors';

const getSiteId = () => connectedStore.applySelector(selectors.getSiteId);

export default getSiteId;
